import { InlinePopupProps } from "csi/middleware/inline/InlinePopup";
import InlineSingleSelect from "csi/middleware/inline/InlineSingleSelect";
import { ComponentItem } from "designSystem/types/component-item-types";
import React, { FunctionComponent, HTMLAttributes, ReactNode } from "react";
import util from "csi/widget/icon/Util";

const TaskActionColorInlineSelect: FunctionComponent<InlinePopupProps> = (props) => {
	function renderOption<T extends ComponentItem>(props: HTMLAttributes<HTMLLIElement>, option: T, { selected }): ReactNode {
		const { id, value } = option;
		return (
			<li 
				{...props} 
				data-csi-value={option.value}
				key={id}
			>
				<div className={util.getTaskActionColorCSS(value)} />
			</li>
		);
	}
	return (
		<InlineSingleSelect
			customRenderOption={renderOption}
			{...props}
		/>
	);
};

export default TaskActionColorInlineSelect;
